import styled, { css } from 'styled-components';
import { ToolbarParent } from '@clds/toolbar-layout';
import { PRIMARY_MENU_MOBILE_HEIGHT, PRIMARY_MENU_WIDTH } from './PrimaryMenu.const';

export const StyledPrimaryMenuCommon = css<{ isDisabled?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  align-items: center;
  background-color: ${(props) => props.theme.palette.surfaceAlt};
  overflow: hidden;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const StyledPrimaryMenu = styled.div<{ isDisabled?: boolean }>`
  ${StyledPrimaryMenuCommon};
  flex-direction: column;
  height: 100%;
  padding-top: ${(props) => props.theme.spacing.sm};
  padding-bottom: ${(props) => props.theme.spacing.md};
  width: ${PRIMARY_MENU_WIDTH};
  z-index: 1;
`;

export const StyledPrimaryMenuMobile = styled.div<{ isDisabled?: boolean }>`
  ${StyledPrimaryMenuCommon};
  padding: 0 ${(props) => props.theme.spacing.xs};
  flex-direction: row;
  height: ${PRIMARY_MENU_MOBILE_HEIGHT};
  width: 100%;
  box-shadow: ${(props) => props.theme.shadow.sm};
`;

export const StyledItemsGroup = styled(ToolbarParent).attrs({ layoutType: 'inner' })`
  display: flex;
  flex-direction: inherit;
  align-items: center;
`;
